/* ---------------------------------------------------
   Animate Highlight Text (Letters Animation)
----------------------------------------------------*/
function initHeaderNavigation() {
  const header = document.querySelector(".header");
  const toggleBtn = document.getElementById("toggleBtn");
  const toggleIcon = document.getElementById("toggleIcon");
  const navMenu = document.getElementById("navMenu");

  if (!header || !navMenu) return;

  const isMobileMenu = () =>
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(max-width: 1024px)").matches;

  const syncMenuState = (isOpen) => {
    navMenu.classList.toggle("open", isOpen);
    document.body.classList.toggle("menu-open", isOpen);

    if (toggleIcon) {
      toggleIcon.textContent = "///";
    }
  };

  if (toggleBtn && toggleBtn.dataset.boundNavToggle !== "1") {
    toggleBtn.addEventListener("click", () => {
      syncMenuState(!navMenu.classList.contains("open"));
    });
    toggleBtn.dataset.boundNavToggle = "1";
  }

  header.querySelectorAll(".nav-link").forEach((link) => {
    if (link.dataset.boundNavLinkClose === "1") return;

    link.addEventListener("click", () => {
      const parentItem = link.parentElement;
      if (parentItem?.classList.contains("menu-item-has-children")) {
        return;
      }

      syncMenuState(false);

      header
        .querySelectorAll(".menu-item-has-children.open")
        .forEach((item) => item.classList.remove("open"));
    });

    link.dataset.boundNavLinkClose = "1";
  });

  header.querySelectorAll(".menu-item-has-children").forEach((parent) => {
    const link = parent.querySelector(":scope > .nav-link");
    if (!link) return;

    if (!link.hasAttribute("aria-expanded")) {
      link.setAttribute("aria-expanded", "false");
    }

    if (link.dataset.boundSubmenuToggle === "1") return;

    link.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const willOpen = !parent.classList.contains("open");

      header
        .querySelectorAll(".menu-item-has-children.open")
        .forEach((item) => {
          if (item !== parent) {
            item.classList.remove("open");
            const itemLink = item.querySelector(":scope > .nav-link");
            itemLink?.setAttribute("aria-expanded", "false");
          }
        });

      parent.classList.toggle("open", willOpen);
      link.setAttribute("aria-expanded", willOpen ? "true" : "false");

      if (isMobileMenu()) {
        syncMenuState(true);
      }
    });

    link.dataset.boundSubmenuToggle = "1";
  });

  if (document.body.dataset.boundHeaderOutsideClick !== "1") {
    document.addEventListener("click", (event) => {
      if (event.target.closest(".menu-item-has-children")) return;

      document
        .querySelectorAll(".menu-item-has-children.open")
        .forEach((item) => {
          item.classList.remove("open");
          const itemLink = item.querySelector(":scope > .nav-link");
          itemLink?.setAttribute("aria-expanded", "false");
        });
    });

    document.body.dataset.boundHeaderOutsideClick = "1";
  }
}

// ==============================
(function () {
  "use strict";

  // ── Elements ──────────────────────────────────────────────
  const carousel = document.querySelector(".hero-carousel");
  if (!carousel) return;

  const words = carousel.querySelectorAll(".hero-carousel-word");
  const descs = carousel.querySelectorAll(".hero-carousel-desc");
  const slides = carousel.querySelectorAll(".hero-carousel-slide");
  const btnPrev = carousel.querySelector(".hero-carousel-arrow--prev");
  const btnNext = carousel.querySelector(".hero-carousel-arrow--next");

  let current = 0;
  let total = slides.length;
  let autoTimer = null;

  if (!total || words.length !== total || descs.length !== total) return;

  // ── Go to slide ───────────────────────────────────────────
  function goTo(index) {
    // Wrap around
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;

    // Remove active from current
    words[current].classList.remove("is-active");
    descs[current].classList.remove("is-active");
    slides[current].classList.remove("is-active");

    // Set new current
    current = index;

    // Add active to new
    words[current].classList.add("is-active");
    descs[current].classList.add("is-active");
    slides[current].classList.add("is-active");
  }

  // ── Word click ────────────────────────────────────────────
  words.forEach(function (word) {
    word.addEventListener("click", function () {
      const index = parseInt(this.dataset.index, 10);
      goTo(index);
      resetAuto();
    });
  });

  // ── Arrow clicks ──────────────────────────────────────────
  if (btnPrev) {
    btnPrev.addEventListener("click", function () {
      goTo(current - 1);
      resetAuto();
    });
  }

  if (btnNext) {
    btnNext.addEventListener("click", function () {
      goTo(current + 1);
      resetAuto();
    });
  }

  // ── Auto advance every 5 seconds ─────────────────────────
  function startAuto() {
    autoTimer = setInterval(function () {
      goTo(current + 1);
    }, 5000);
  }

  function resetAuto() {
    clearInterval(autoTimer);
    startAuto();
  }

  // ── Keyboard support ─────────────────────────────────────
  document.addEventListener("keydown", function (e) {
    if (e.key === "ArrowLeft") {
      goTo(current - 1);
      resetAuto();
    }
    if (e.key === "ArrowRight") {
      goTo(current + 1);
      resetAuto();
    }
  });

  // ── Init ─────────────────────────────────────────────────
  goTo(0);
  startAuto();
})();

// =================================== visit showcase
(function () {
  "use strict";

  const slider = document.querySelector(".visit-slider");
  if (!slider) return;

  const track = slider.querySelector(".visit-slider__track");
  const slides = slider.querySelectorAll(".visit-slider__slide");
  const btnPrev = slider.querySelector(".visit-slider__arrow--prev");
  const btnNext = slider.querySelector(".visit-slider__arrow--next");

  if (!track || slides.length === 0) return;

  let current = 0;
  const total = slides.length;

  // ── Move track to current slide ───────────────────────────
  function goTo(index) {
    // Wrap around
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;

    current = index;

    // Slide track — translateX by -100% * index
    track.style.transform = `translateX(-${current * 100}%)`;
  }

  // ── Arrow clicks ──────────────────────────────────────────
  if (btnPrev) {
    btnPrev.addEventListener("click", function () {
      goTo(current - 1);
      resetAuto();
    });
  }

  if (btnNext) {
    btnNext.addEventListener("click", function () {
      goTo(current + 1);
      resetAuto();
    });
  }

  // ── Auto advance every 5s ─────────────────────────────────
  let autoTimer = null;

  function startAuto() {
    autoTimer = setInterval(function () {
      goTo(current + 1);
    }, 5000);
  }

  function resetAuto() {
    clearInterval(autoTimer);
    startAuto();
  }

  // ── Touch / Swipe support ─────────────────────────────────
  let touchStartX = 0;
  let touchEndX = 0;

  track.addEventListener(
    "touchstart",
    function (e) {
      touchStartX = e.changedTouches[0].screenX;
    },
    { passive: true },
  );

  track.addEventListener(
    "touchend",
    function (e) {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > 50) {
        // min 50px swipe
        if (diff > 0) {
          goTo(current + 1); // swipe left → next
        } else {
          goTo(current - 1); // swipe right → prev
        }
        resetAuto();
      }
    },
    { passive: true },
  );

  // ── Keyboard support ──────────────────────────────────────
  document.addEventListener("keydown", function (e) {
    if (e.key === "ArrowLeft") {
      goTo(current - 1);
      resetAuto();
    }
    if (e.key === "ArrowRight") {
      goTo(current + 1);
      resetAuto();
    }
  });

  // ── Init ──────────────────────────────────────────────────
  goTo(0);
  startAuto();
})();

// ============================= sufflin

(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".mission-section").forEach(function (section) {
      const shuffleBtn = section.querySelector("[data-mission-shuffle]");
      const grid = section.querySelector("[data-mission-grid]");

      if (!shuffleBtn || !grid) return;

      const mobileQuery = window.matchMedia("(max-width: 566px)");
      const mobileVisibleCount = 3;
      let isAnimating = false;

      function shuffleArray(arr) {
        const shuffled = [...arr];

        for (let i = shuffled.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }

        if (
          shuffled.every(function (card, index) {
            return card === arr[index];
          })
        ) {
          shuffled.push(shuffled.shift());
        }

        return shuffled;
      }

      function visibleCards(cards) {
        if (!mobileQuery.matches) {
          return cards;
        }

        return cards.slice(0, mobileVisibleCount);
      }

      function syncMobileCards() {
        const cards = Array.from(grid.querySelectorAll(".card"));

        cards.forEach(function (card, index) {
          card.classList.toggle(
            "is-mission-hidden",
            mobileQuery.matches && index >= mobileVisibleCount,
          );
        });
      }

      function clearCardStyles(cards) {
        cards.forEach(function (card) {
          card.style.transitionDelay = "";
          card.style.transform = "";
          card.style.opacity = "";
          card.style.pointerEvents = "";
        });
      }

      shuffleBtn.addEventListener("click", function () {
        if (isAnimating) return;

        const cards = Array.from(grid.querySelectorAll(".card"));
        const cardsToAnimateOut = visibleCards(cards);

        if (cards.length < 2) return;

        isAnimating = true;
        shuffleBtn.disabled = true;
        shuffleBtn.classList.add("is-shuffling");

        cardsToAnimateOut.forEach(function (card, i) {
          card.style.transitionDelay = i * 40 + "ms";
          card.style.transform = "translateX(-40px)";
          card.style.opacity = "0";
          card.style.pointerEvents = "none";
        });

        window.setTimeout(
          function () {
            const shuffled = shuffleArray(cards);

            shuffled.forEach(function (card) {
              grid.appendChild(card);
              card.style.transitionDelay = "0ms";
              card.style.transform = "translateX(40px)";
              card.style.opacity = "0";
            });

            syncMobileCards();

            void grid.offsetWidth;

            const cardsToAnimateIn = visibleCards(shuffled);

            cardsToAnimateIn.forEach(function (card, i) {
              card.style.transitionDelay = i * 50 + "ms";
              card.style.transform = "translateX(0)";
              card.style.opacity = "1";
            });

            window.setTimeout(
              function () {
                clearCardStyles(shuffled);
                shuffleBtn.disabled = false;
                shuffleBtn.classList.remove("is-shuffling");
                isAnimating = false;
              },
              350 + cardsToAnimateIn.length * 50,
            );
          },
          350 + cardsToAnimateOut.length * 40,
        );
      });

      syncMobileCards();

      if (typeof mobileQuery.addEventListener === "function") {
        mobileQuery.addEventListener("change", syncMobileCards);
      } else if (typeof mobileQuery.addListener === "function") {
        mobileQuery.addListener(syncMobileCards);
      }
    });
  });
})();

// =================================== Resource Center — Sort / Filter dropdowns
(function () {
  "use strict";

  var documentListenersBound = false;

  function closeAllDropdowns() {
    document.querySelectorAll("[data-rc-dropdown]").forEach(function (dd) {
      var btn = dd.querySelector("button");
      var menu = dd.querySelector(".rc-dropdown__menu");
      dd.classList.remove("is-open");
      if (btn) {
        btn.setAttribute("aria-expanded", "false");
      }
      if (menu) {
        menu.hidden = true;
      }
    });
  }

  function bindResourceCenterDropdowns() {
    var dropdowns = document.querySelectorAll("[data-rc-dropdown]");

    dropdowns.forEach(function (dd) {
      if (dd.dataset.rcDropdownBound === "1") {
        return;
      }

      var btn = dd.querySelector("button");
      var menu = dd.querySelector(".rc-dropdown__menu");

      if (!btn || !menu) {
        return;
      }

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isOpen = dd.classList.contains("is-open");

        closeAllDropdowns();

        if (!isOpen) {
          dd.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");
          menu.hidden = false;
        }
      });

      menu.addEventListener("click", function (e) {
        e.stopPropagation();
      });

      dd.dataset.rcDropdownBound = "1";
    });

    if (!documentListenersBound && dropdowns.length) {
      document.addEventListener("click", closeAllDropdowns);
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          closeAllDropdowns();
        }
      });
      documentListenersBound = true;
    }
  }

  function initResourceCenterDropdowns() {
    bindResourceCenterDropdowns();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initResourceCenterDropdowns);
  } else {
    initResourceCenterDropdowns();
  }

  window.initResourceCenterDropdowns = initResourceCenterDropdowns;
})();

// =================================== resource center rows
(function () {
  "use strict";

  const rows = document.querySelectorAll("[data-rc-row]");
  if (!rows.length) return;

  rows.forEach(function (row) {
    row.addEventListener("mouseenter", function () {
      row.classList.add("is-open");
    });

    row.addEventListener("mouseleave", function () {
      row.classList.remove("is-open");
    });

    row.addEventListener("focusin", function () {
      row.classList.add("is-open");
    });

    row.addEventListener("focusout", function () {
      row.classList.remove("is-open");
    });
  });
})();

// ================================= header menu

// ============================================================
// HEADER.JS — Mobile menu slide from right
// ============================================================

(function () {
  "use strict";

  function initMobileMenu() {
    const toggle = document.querySelector(".menu-toggle");
    const menu = document.querySelector("#mobile-menu");
    const backdrop = document.querySelector(".mobile-menu__backdrop");
    const closeBtn = document.querySelector(".mobile-menu__close");
    const body = document.body;

    if (!toggle || !menu || toggle.dataset.mobileMenuBound === "1") return;

    function openMenu() {
      menu.classList.add("is-open");
      menu.setAttribute("aria-hidden", "false");
      toggle.classList.add("is-active");
      toggle.setAttribute("aria-expanded", "true");
      toggle.setAttribute("aria-label", "Close menu");
      backdrop && backdrop.classList.add("is-visible");
      body.classList.add("menu-open");

      const firstLink = menu.querySelector(
        ".mobile-menu__nav a, .mobile-menu__close",
      );
      if (firstLink) {
        window.setTimeout(function () {
          firstLink.focus();
        }, 400);
      }
    }

    function closeMenu(restoreFocus) {
      menu.classList.remove("is-open");
      menu.setAttribute("aria-hidden", "true");
      toggle.classList.remove("is-active");
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open menu");
      backdrop && backdrop.classList.remove("is-visible");
      body.classList.remove("menu-open");

      if (restoreFocus !== false) {
        toggle.focus();
      }
    }

    toggle.addEventListener("click", function (event) {
      event.preventDefault();
      const isOpen = menu.classList.contains("is-open");
      isOpen ? closeMenu(false) : openMenu();
    });

    closeBtn &&
      closeBtn.addEventListener("click", function () {
        closeMenu();
      });

    backdrop &&
      backdrop.addEventListener("click", function () {
        closeMenu(false);
      });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && menu.classList.contains("is-open")) {
        closeMenu();
      }
    });

    menu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        closeMenu(false);
      });
    });

    toggle.dataset.mobileMenuBound = "1";
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMobileMenu);
  } else {
    initMobileMenu();
  }
})();

// ======================================== header sticky

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".site-header");
  if (!header) return;

  const body = document.body;
  const isHomepage = body.classList.contains("homepage-header");

  // Set CSS variable scoped to body
  function updateHeaderHeight() {
    if (isHomepage) {
      body.style.setProperty("--header-height", "0px");
    } else {
      body.style.setProperty("--header-height", header.offsetHeight + "px");
    }
  }

  updateHeaderHeight();
  window.addEventListener("resize", updateHeaderHeight, { passive: true });

  // Scroll handler
  window.addEventListener(
    "scroll",
    () => {
      header.classList.toggle("is-scrolled", window.scrollY > 10);
    },
    { passive: true },
  );
});

// ========================================= Faq section
(function () {
  "use strict";

  function setOpen(item, isOpen) {
    var btn = item.querySelector(".fqAction");

    item.classList.toggle("is-open", isOpen);

    if (btn) {
      btn.textContent = isOpen ? "-" : "+";
      btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }
  }

  function initFaqSection(section) {
    if (!section || section.dataset.faqBound === "1") {
      return;
    }

    section.querySelectorAll(".faqListItem").forEach(function (item) {
      var head = item.querySelector(".fqHead");
      if (!head) {
        return;
      }

      setOpen(item, item.classList.contains("is-open"));

      head.addEventListener("click", function () {
        setOpen(item, !item.classList.contains("is-open"));
      });
    });

    section.dataset.faqBound = "1";
  }

  function initFaqSections() {
    document.querySelectorAll(".faqSec").forEach(initFaqSection);
  }

  window.initFaqSections = initFaqSections;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFaqSections);
  } else {
    initFaqSections();
  }
})();

// ======================= support page slider

(function () {
  "use strict";

  function initSliders() {
    const sliders = document.querySelectorAll(".events-slider__slider");

    sliders.forEach(function (slider) {
      const track = slider.querySelector(".slider-track");
      const slides = slider.querySelectorAll(".slider-slide");
      const prevBtn = slider.querySelector(".slider-btn--prev");
      const nextBtn = slider.querySelector(".slider-btn--next");

      if (!track || slides.length <= 1) return;

      // FIX 3: set transition in JS (was commented-out in SCSS)
      track.style.transition = "transform 0.4s ease";
      track.style.willChange = "transform";

      let currentIndex = 0;
      const totalSlides = slides.length;
      let autoPlayInterval;

      // FIX 1+2: removed setSlideWidths(); use container width for translateX
      function updateSlider() {
        const slideWidth = slider.offsetWidth; // container, not slide DOM node
        track.style.transform =
          "translateX(" + -currentIndex * slideWidth + "px)";
      }

      function goToNext() {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider();
      }

      function goToPrev() {
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        updateSlider();
      }

      function startAutoPlay() {
        autoPlayInterval = setInterval(goToNext, 5000);
      }

      function stopAutoPlay() {
        clearInterval(autoPlayInterval);
      }

      // FIX 4: null-check buttons before attaching listeners
      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          stopAutoPlay();
          goToNext();
          startAutoPlay();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          stopAutoPlay();
          goToPrev();
          startAutoPlay();
        });
      }

      // Keyboard navigation
      slider.setAttribute("tabindex", "0");
      slider.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") {
          stopAutoPlay();
          goToNext();
          startAutoPlay();
        } else if (e.key === "ArrowLeft") {
          stopAutoPlay();
          goToPrev();
          startAutoPlay();
        }
      });

      // Touch/swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      track.addEventListener(
        "touchstart",
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
          stopAutoPlay();
        },
        { passive: true },
      );

      track.addEventListener(
        "touchend",
        function (e) {
          touchEndX = e.changedTouches[0].screenX;
          const diff = touchStartX - touchEndX;
          if (Math.abs(diff) > 50) {
            diff > 0 ? goToNext() : goToPrev();
          }
          startAutoPlay();
        },
        { passive: true },
      );

      // Resize handler — re-snap to current slide
      let resizeTimer;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          // pause transition briefly so snap is instant
          track.style.transition = "none";
          updateSlider();
          setTimeout(function () {
            track.style.transition = "transform 0.4s ease";
          }, 50);
        }, 250);
      });

      // Init
      updateSlider();
      startAutoPlay();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSliders);
  } else {
    initSliders();
  }
})();

// ==========================================  ajex
(function () {
  "use strict";

  const block = document.querySelector("[data-rc-block]");
  if (!block) return;

  const resultsEl = block.querySelector("[data-rc-results]");
  const activeFiltersEl = block.querySelector("[data-rc-active-filters]");
  const searchInputs = block.querySelectorAll("[data-rc-search]");
  const mobileControls = block.querySelector("[data-rc-mobile-controls]");
  const mobileSearch = block.querySelector("[data-rc-mobile-search]");
  const mobileSearchOpen = block.querySelector("[data-rc-mobile-search-open]");
  const mobileSearchClose = block.querySelector(
    "[data-rc-mobile-search-close]",
  );
  const mobileFilter = block.querySelector("[data-rc-mobile-filter]");
  const mobileFilterToggle = block.querySelector(
    "[data-rc-mobile-filter-toggle]",
  );
  const mobileFilterCloseControls = block.querySelectorAll(
    "[data-rc-mobile-filter-close]",
  );
  const mobileFilterPanel = mobileFilter
    ? mobileFilter.querySelector(".rc-mobile-filter__panel")
    : null;
  const ajaxUrl = block.dataset.rcAjax;
  const nonce = block.dataset.rcNonce;

  // ── State ──────────────────────────────────────────────
  const state = {
    rc_sort: new URLSearchParams(location.search).get("rc_sort") || "newest",
    rc_type: new URLSearchParams(location.search).get("rc_type") || "",
    rc_search: new URLSearchParams(location.search).get("rc_search") || "",
    rc_page: parseInt(
      new URLSearchParams(location.search).get("rc_page") || "1",
    ),
  };

  // ── Core fetch function ────────────────────────────────
  async function fetchResults(pushHistory = true) {
    resultsEl.setAttribute("aria-busy", "true");
    resultsEl.classList.add("is-loading");

    const body = new FormData();
    body.append("action", "rc_fetch");
    body.append("nonce", nonce);
    body.append("rc_sort", state.rc_sort);
    body.append("rc_type", state.rc_type);
    body.append("rc_search", state.rc_search);
    body.append("rc_page", state.rc_page);

    try {
      const res = await fetch(ajaxUrl, { method: "POST", body });
      const data = await res.json();

      if (data.success) {
        resultsEl.innerHTML = data.data.html;
        bindPaginationButtons(); // re-bind after swap
        updateActiveFilters();

        if (pushHistory) {
          const url = buildURL();
          history.pushState({ ...state }, "", url);
        }

        // Scroll to top of results (smooth)
        resultsEl.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } catch (err) {
      console.error("Resource Center fetch error:", err);
    } finally {
      resultsEl.removeAttribute("aria-busy");
      resultsEl.classList.remove("is-loading");
    }
  }

  // ── Build URL from state ───────────────────────────────
  function buildURL() {
    const params = new URLSearchParams();
    if (state.rc_sort && state.rc_sort !== "newest")
      params.set("rc_sort", state.rc_sort);
    if (state.rc_type) params.set("rc_type", state.rc_type);
    if (state.rc_search) params.set("rc_search", state.rc_search);
    if (state.rc_page > 1) params.set("rc_page", state.rc_page);
    const qs = params.toString();
    return location.pathname + (qs ? "?" + qs : "");
  }

  // ── Active filter tags ─────────────────────────────────
  function updateActiveFilters() {
    const tags = [];

    if (state.rc_type) {
      // Get label from the filter button
      const btn = block.querySelector(`[data-rc-filter="${state.rc_type}"]`);
      const label = btn ? btn.textContent.trim() : state.rc_type;
      tags.push({ label, key: "rc_type" });
    }

    if (state.rc_search) {
      tags.push({ label: state.rc_search, key: "rc_search" });
    }

    if (tags.length === 0) {
      activeFiltersEl.innerHTML = "";
      return;
    }

    activeFiltersEl.innerHTML = tags
      .map(
        (tag) => `
      <span class="rc-filter-tag">
        ${escHtml(tag.label)}
        <button type="button" class="rc-filter-tag__remove" data-rc-remove="${tag.key}" aria-label="Remove ${escHtml(tag.label)}">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </span>
    `,
      )
      .join("");

    // Bind remove buttons
    activeFiltersEl.querySelectorAll("[data-rc-remove]").forEach((btn) => {
      btn.addEventListener("click", function () {
        const key = this.dataset.rcRemove;
        state[key] = "";
        state.rc_page = 1;
        updateDropdownActiveStates();
        fetchResults();
      });
    });
  }

  // ── Update dropdown button active states ──────────────
  function updateDropdownActiveStates() {
    block.querySelectorAll("[data-rc-sort]").forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.rcSort === state.rc_sort);
      btn.setAttribute(
        "aria-current",
        btn.dataset.rcSort === state.rc_sort ? "true" : "false",
      );
    });
    block.querySelectorAll("[data-rc-filter]").forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.rcFilter === state.rc_type);
      btn.setAttribute(
        "aria-pressed",
        btn.dataset.rcFilter === state.rc_type ? "true" : "false",
      );
    });

    searchInputs.forEach((input) => {
      input.value = state.rc_search;
    });
  }

  // ── Sort buttons ───────────────────────────────────────
  block.querySelectorAll("[data-rc-sort]").forEach((btn) => {
    btn.addEventListener("click", function () {
      state.rc_sort = this.dataset.rcSort;
      state.rc_page = 1;
      updateDropdownActiveStates();
      closeAllDropdowns();
      closeMobileFilter();
      fetchResults();
    });
  });

  // ── Filter buttons ─────────────────────────────────────
  block.querySelectorAll("[data-rc-filter]").forEach((btn) => {
    btn.addEventListener("click", function () {
      const slug = this.dataset.rcFilter;
      // Toggle off if already active
      state.rc_type = state.rc_type === slug ? "" : slug;
      state.rc_page = 1;
      updateDropdownActiveStates();
      closeAllDropdowns();
      closeMobileFilter();
      fetchResults();
    });
  });

  // ── Search — debounced ─────────────────────────────────
  let searchTimer;
  searchInputs.forEach((input) => {
    input.addEventListener("input", function () {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        state.rc_search = this.value.trim();
        state.rc_page = 1;
        updateDropdownActiveStates();
        fetchResults();
      }, 400); // 400ms debounce
    });
  });

  // ── Pagination — delegated (re-bound after each swap) ──
  function bindPaginationButtons() {
    resultsEl.querySelectorAll("[data-rc-page]").forEach((btn) => {
      btn.addEventListener("click", function () {
        state.rc_page = parseInt(this.dataset.rcPage);
        fetchResults();
      });
    });
  }
  bindPaginationButtons(); // bind on initial load too

  // ── Dropdown open/close ────────────────────────────────
  block.querySelectorAll("[data-rc-dropdown]").forEach((dropdown) => {
    const toggle = dropdown.querySelector("button[aria-expanded]");
    const menu = dropdown.querySelector(".rc-dropdown__menu");

    toggle.addEventListener("click", function () {
      const isOpen = this.getAttribute("aria-expanded") === "true";
      closeAllDropdowns();
      if (!isOpen) {
        this.setAttribute("aria-expanded", "true");
        menu.hidden = false;
      }
    });
  });

  function closeAllDropdowns() {
    block.querySelectorAll("[data-rc-dropdown]").forEach((d) => {
      const t = d.querySelector("button[aria-expanded]");
      const m = d.querySelector(".rc-dropdown__menu");
      if (t) t.setAttribute("aria-expanded", "false");
      if (m) m.hidden = true;
    });
  }

  function openMobileSearch() {
    if (!mobileSearch) return;

    closeMobileFilter(false);
    closeAllDropdowns();
    mobileSearch.hidden = false;
    block.classList.add("is-rc-searching");

    const input = mobileSearch.querySelector("[data-rc-search]");
    if (input) {
      window.setTimeout(() => input.focus(), 0);
    }
  }

  function closeMobileSearch(restoreFocus = true) {
    if (!mobileSearch) return;

    mobileSearch.hidden = true;
    block.classList.remove("is-rc-searching");

    if (restoreFocus && mobileSearchOpen) {
      mobileSearchOpen.focus();
    }
  }

  function openMobileFilter() {
    if (!mobileFilter) return;

    closeMobileSearch(false);
    closeAllDropdowns();
    mobileFilter.hidden = false;
    mobileFilter.setAttribute("aria-hidden", "false");
    mobileFilterToggle?.setAttribute("aria-expanded", "true");
    document.body.classList.add("rc-mobile-filter-open");

    if (mobileFilterPanel) {
      window.setTimeout(() => mobileFilterPanel.focus(), 0);
    }
  }

  function closeMobileFilter(restoreFocus = true) {
    if (!mobileFilter || mobileFilter.hidden) return;

    mobileFilter.hidden = true;
    mobileFilter.setAttribute("aria-hidden", "true");
    mobileFilterToggle?.setAttribute("aria-expanded", "false");
    document.body.classList.remove("rc-mobile-filter-open");

    if (restoreFocus && mobileFilterToggle) {
      mobileFilterToggle.focus();
    }
  }

  if (mobileSearchOpen) {
    mobileSearchOpen.addEventListener("click", openMobileSearch);
  }

  if (mobileSearchClose) {
    mobileSearchClose.addEventListener("click", function () {
      closeMobileSearch();
    });
  }

  if (mobileFilterToggle) {
    mobileFilterToggle.addEventListener("click", function () {
      if (mobileFilter && !mobileFilter.hidden) {
        closeMobileFilter();
      } else {
        openMobileFilter();
      }
    });
  }

  mobileFilterCloseControls.forEach((control) => {
    control.addEventListener("click", function () {
      closeMobileFilter();
    });
  });

  // Close dropdowns on outside click
  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-rc-dropdown]")) {
      closeAllDropdowns();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;

    if (mobileFilter && !mobileFilter.hidden) {
      closeMobileFilter();
      return;
    }

    if (mobileSearch && !mobileSearch.hidden) {
      closeMobileSearch();
      return;
    }

    closeAllDropdowns();
  });

  // ── Browser back/forward ───────────────────────────────
  window.addEventListener("popstate", function (e) {
    if (e.state) {
      Object.assign(state, e.state);
      updateDropdownActiveStates();
      fetchResults(false); // don't push — we're popping
    }
  });

  // ── Helpers ────────────────────────────────────────────
  function escHtml(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  // Init active filters on load
  updateDropdownActiveStates();
  updateActiveFilters();
})();
